<div *ngIf="currentImage as image" class="image-overlay" dir="rtl" (click)="close.emit()">
  <section class="image-dialog" role="dialog" aria-modal="true" aria-labelledby="image-dialog-title" (click)="$event.stopPropagation()">
    <div class="dialog-heading">
      <strong id="image-dialog-title">{{ image.name }}</strong>
      <button id="image-dialog-close" class="button" type="button" (click)="close.emit()">بستن</button>
    </div>
    <div class="tabs dialog-tabs" aria-label="دسته تصویر">
      <button type="button" [class.active]="image.category === 'cabin'" [attr.aria-pressed]="image.category === 'cabin'" [disabled]="!hasModalCategory('cabin')" (click)="selectModalCategory('cabin')">کابین</button>
      <button type="button" [class.active]="image.category === 'outside'" [attr.aria-pressed]="image.category === 'outside'" [disabled]="!hasModalCategory('outside')" (click)="selectModalCategory('outside')">بیرون</button>
    </div>
    <img *ngIf="!modalImageFailed" class="dialog-image" [src]="image.fullUrl" [alt]="'تصویر ' + image.name" (error)="modalImageFailed = true">
    <p *ngIf="modalImageFailed" class="dialog-empty" role="status">تصویر در دسترس نیست.</p>
    <p class="dialog-info">{{ image.name }} <span *ngIf="image.plate"> | {{ image.plate }}</span></p>
    <div class="dialog-actions">
      <a class="button" [routerLink]="['/surveillance', image.unitId]" target="_blank" rel="noopener">نمایش دوربین</a>
      <a class="button" [routerLink]="['/carInfo', image.unitId]" target="_blank" rel="noopener">مشخصات خودرو</a>
    </div>
  </section>
</div>
